"use strict";
// @ts-ignore
try {
    self['workbox:streams:5.1.4'] && _();
}
catch (e) { }
